import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import StarRating from "../../components/StarRating";
import { DeleteButton } from "./ui";

export default function ReviewsTab() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () =>
    api.get("/admin/reviews")
      .then(({ data }) => setReviews(data))
      .catch(() => {})
      .finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const remove = async (r) => {
    try {
      await api.delete(`/admin/reviews/${r.id}`);
      toast.success("REPORT PURGED");
      setReviews((prev) => prev.filter((x) => x.id !== r.id));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  if (loading) return <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted">LOADING REPORTS…</p>;

  return (
    <div data-testid="admin-reviews-tab">
      <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.2em] text-muted">
        {reviews.length} trader reports on file — deletion is permanent
      </p>
      <div className="space-y-px border border-white/10 bg-white/10" data-testid="admin-reviews-list">
        {reviews.length === 0 && (
          <p className="bg-ink p-7 font-mono text-xs uppercase tracking-[0.2em] text-muted" data-testid="admin-reviews-empty">
            No reports filed yet.
          </p>
        )}
        {reviews.map((r) => (
          <div key={r.id} className="flex flex-col gap-4 bg-ink p-6 sm:flex-row sm:items-start sm:justify-between" data-testid={`admin-review-${r.id}`}>
            <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-3">
                <span className="text-sm font-600 text-white">{r.name}</span>
                <span className="border border-signal/40 px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.15em] text-signal">{r.firm_name}</span>
                <StarRating value={r.rating} size={12} idPrefix={`admin-${r.id.slice(0, 6)}`} />
              </div>
              {r.title && <p className="mt-2 font-display text-base font-700 text-white">{r.title}</p>}
              <p className="mt-1.5 text-sm leading-relaxed text-muted">{r.comment}</p>
              <p className="mt-2 font-mono text-[9px] uppercase tracking-[0.2em] text-muted">
                {new Date(r.created_at).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" })}
              </p>
            </div>
            <DeleteButton testId={`delete-review-${r.id}`} onConfirm={() => remove(r)} />
          </div>
        ))}
      </div>
    </div>
  );
}
